export const BLOCK_TYPES = {
  HEADER: "header",
  TEXT: "text",
  IMAGE: "image",
  MARKDOWN: "markdown",
  QUOTE: "quote",
  DIVIDER: "divider",
};
